import React, { useMemo } from 'react';
import styles from './PurchaseProgressOverlay.module.css';

export default function PurchaseProgressOverlay({
  open = false,
  title = 'Completing your purchase',
  caption = 'Please keep this window open while we secure your collectible.',
  steps = [],
  activeStep = 0,
}) {
  const safeStep = Math.max(0, Math.min(activeStep, Math.max(steps.length - 1, 0)));
  const currentStep = useMemo(() => steps[safeStep] || null, [safeStep, steps]);
  if (!open) return null;

  return (
    <div className={styles.backdrop} role="presentation">
      <div className={styles.panel} role="status" aria-live="polite">
        <div className={styles.spinner} aria-hidden="true" />
        <span className={styles.eyebrow}>Purchase in progress</span>
        <h2>{title}</h2>
        <strong className={styles.stepTitle}>{currentStep?.label || 'Processing purchase'}</strong>
        <p>{currentStep?.detail || caption}</p>
      </div>
    </div>
  );
}
